import React, { Component } from 'react';
import './ButtonToTop.css';
import { Link } from 'react-router';

class ButtonToTop extends Component {
    render() {
      return (
          <Link className="Button-To-Top" to="top">
              <i className="material-icons">vertical_align_top</i>
          </Link>
      );
  }
}

export default ButtonToTop;



// WEBPACK FOOTER //
// ./src/components/ButtonToTop/ButtonToTop.js